import React from "react";
import { Button, Modal } from "semantic-ui-react";

function exampleReducer(state, action) {
  switch (action.type) {
    case "close":
      return { open: false };
    case "open":
      return { open: true, size: action.size };
    default:
      throw new Error("Unsupported action...");
  }
}

const WriteReviewModal = (props) => {
  const [state, dispatch] = React.useReducer(exampleReducer, {
    open: false,
    size: undefined,
    
    size: "small",
  });
  const { open, size } = state;

  return (
    <>
      <span
        style={{ fontSize: "1.2rem", marginTop: "1rem", cursor: "pointer" }}
        onClick={() => { dispatch({ type: "open", size: "small" });}}
      >
        {props.children[0]}
      </span>

      <Modal
        size={size}
        open={open}
        onClose={() => dispatch({ type: "close" })}
        style={{zIndex: 10000}}
      >
        <Modal.Header>{props.children[1]}</Modal.Header>
        <Modal.Content>{props.children[2]}</Modal.Content>
        <Modal.Actions>
          {props.children[3]}
          <span id={`reviews${props.receipt}`}>
            <Button   negative  onClick={() => dispatch({ type: "close" })}>
              Close
            </Button>
          </span>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default WriteReviewModal;
